import axios from 'axios'
import { convertAdBannerItem } from './converters/adBannerConverter'
import { convertHospitalCount } from './converters/hospitalCountConverter'
import { convertHomeHospitalItem } from './converters/homeHospitalConverter'
import { AdBannerResponseItem, AdBannerItem } from '@/types/AdBanner'
import { HomeHospitalResponseItem } from '@/types/HomeHospital'

const APP_API_TIMEOUT = 30000

function getCsrfToken(): string {
  const csrfElement = document.querySelector('meta[name="csrf-token"]')
  if (!csrfElement) return ''
  return `${csrfElement.getAttribute('content')}`
}

const appApiV1 = axios.create({
  baseURL: `/api/v1/`,
  timeout: APP_API_TIMEOUT,
  headers: { 'X-CSRF-TOKEN': getCsrfToken() }
})

export async function getHospitalCount() {
  const res = await appApiV1.get('j_search/cnt')
  return {
    ...res,
    data: convertHospitalCount(res.data)
  }
}

export async function getRecommendedHospitals(areaId?: string) {
  const path = areaId
    ? `j_search/recommend?prefectures=${areaId}`
    : 'j_search/recommend'
  const res = await appApiV1.get(path)
  return {
    ...res,
    data: res.data.map((item: HomeHospitalResponseItem) => {
      return convertHomeHospitalItem(item)
    })
  }
}

export async function getPickupHospitals() {
  const path = 'j_search/pickup'
  const res = await appApiV1.get(path)
  return {
    ...res,
    data: res.data.map((item: HomeHospitalResponseItem) => {
      return convertHomeHospitalItem(item)
    })
  }
}

export async function getAdBanners(optId: number, prefectures?: number[]) {
  const res = await appApiV1.get('banner', {
    params: {
      opt_id: optId,
      prefectures
    }
  })
  return {
    ...res,
    data: res.data.map(
      (item: AdBannerResponseItem): AdBannerItem => {
        return convertAdBannerItem(item)
      }
    )
  }
}
